import { render, staticRenderFns } from "./RoomGuest.vue?vue&type=template&id=1f05c61f&scoped=true"
import script from "./RoomGuest.vue?vue&type=script&lang=js"
export * from "./RoomGuest.vue?vue&type=script&lang=js"
import style0 from "./RoomGuest.vue?vue&type=style&index=0&id=1f05c61f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f05c61f",
  null
  
)

export default component.exports